<template>
  <div class="card">

    <div class="card-content">
      <line-chart-free :height="300" :chart-data="chartData" :titulo="'Dispositivos percebidos pela rede WiFi'"></line-chart-free>
    </div>
  </div>
</template>

<script>
import LineChartFree from "@/components/charts/LineChartFree";
var moment = require("moment");
export default {
  name: "SensoredLine",
  components: { LineChartFree },
  props: ["data", "settings", "segdata"],
  data() {
    return {
      inner_settings: { periodo: 24 },
      inner_data: { devices: [], sensored: [] },
      intervalo: 30,
      delta: 0,
      labels: [],
      rotated: false
    };
  },
  mounted() {
    this.inner_settings = this.settings;
    this.inner_data = this.segdata;
  },
  computed: {
    chartData() {
      var self = this;

      var newData = { labels: [], sensored: [], devices: [] };
    if(self.data && self.data[0]){
    
      try {
        newData = segmentData(
          self.data,
          this.intervalo,
          "minute",
          self.data[0].datetime,
          self.data[self.data.length - 1].datetime
        );

        self.inner_data.devices = newData.devices;
        self.inner_data.sensored = newData.sensored;
      } catch (exc) {
        console.log(">>", exc);
      }

      return {
        labels: newData.labels,
        datasets: [
          {
            label: "Detectados",
            borderColor: "#f2476a",
            data: newData.sensored,
            borderWidth: 2,
            pointBackgroundColor: "#fff",
            lineTension: 0,
            pointRadius: 2
          },
          {
            label: "Conectados",
            borderWidth: 2,
            borderColor: "#92a8d1",
            data: newData.devices,
            pointBackgroundColor: "#fff",
            lineTension: 0,
            pointRadius: 2
          },
        ]
      };
      }
    }
  }
};

function segmentData(
  data,
  intervalValue,
  intervalType,
  datetimeStart,
  datetimeEnd
) {
  var dates = [];

  var currDate = moment(datetimeStart).startOf(intervalType);
  var lastDate = moment(datetimeEnd).startOf(intervalType);

  while (currDate.add(intervalValue, intervalType + "s").diff(lastDate) < 0) {
    dates.push(currDate.clone().toDate());
  }

  var sensored = [];
  var devices = [];
  var labels = [];

  var dtLast = dates[0];
  var initial = 0;

  dates.forEach(dtCurr => {
    var avg = {
      devices: 0,
      sensored_max: 0,
      datetime: moment(dtCurr).format("HH:mm")
    };
    var ct = 0;
    var found = false;

    for (var i = initial; i < data.length && !found; i++) {
      var currData = data[i];

      if (
        moment(currData.datetime).diff(dtCurr, intervalType + "s") >=
        intervalValue
      ) {
        found = true;
        initial = i;
      } else {
        avg.devices += currData.devices;
        avg.sensored_max = avg.sensored_max < currData.sensored ? currData.sensored : avg.sensored_max ;
        ct++;
      }
    }

    if (ct != 0) {
      avg.devices = Math.ceil(avg.devices / ct);
      //avg.sensored = Math.ceil(avg.sensored / ct);
    }

    sensored.push(avg.sensored_max);
    devices.push(avg.devices);
    labels.push(avg.datetime);
  });

  return {
    labels: labels,
    sensored: sensored,
    devices: devices
  };
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed|Titillium+Web");

span.subtitle {
  color: gray;
  text-transform: uppercase;
  font-size: medium;
  font-weight: 200;
}

div.root {
  padding: 0;
  margin: 2px;
  width: 100%;
  height: 140px;
  background-color: #ffffff;
  display: inline-block;
}

div.box-title {
  width: 112px;
  height: 25px;
  font-family: "Roboto Condensed", "Arial Narrow";
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.39;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
}

div.box-value {
  font-family: "Titillium Web", "Arial";
  font-size: 28px;
  font-weight: bold;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: black;
}

div.box-footer {
  width: 146px;
  height: 20px;
  font-family: Arial;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: condensed;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
}
div.small {
  font-size: x-small;
}

.trend-icon {
  margin-bottom: 8px !important;
}

div.circle {
  background: #1eeb2e;
  display: inline-block;
  margin: 0 0 2px 0;
  border-radius: 50%;
  height: 12px;
  width: 12px;
}
.v-card__text {
  padding-bottom: 0px;
  padding-left: 0px;
  padding-top: 40px;
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/SensoredLine.vue